<template>
  <div class="loadingfullwrapper">
    <div class="loadingfull">
      <!-- <img src="static/img/spinner.gif" class="spinnerfull"> -->
      <i class="fa fa-circle-o-notch fa-spin fa-5x fa-fw spinnerfull text-warning"></i>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scope>

.loadingfullwrapper {
  position: fixed;
  z-index: 10000;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loadingfullwrapper:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}

.loadingfull {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
}

.spinnerfull {
  margin: auto;
  z-index: 10001;
}

</style>
